import request from "../utils/request";

export function getPendencies() {
  return request({
    url: `/events/pendencies`,
    method: "get",
  });
}

export function markAsRead(notification) {
  return request({
    url: `/notifications/${notification._id}`,
    method: "post",
    data: {
      read: true,
    },
  });
}
